export default "__VITE_ASSET__BH1TOUcA__"